<template>
    <div class="entry-preview">
        <b-modal title="Preview" header-bg-variant="info" header-text-variant="light" ref="modal" size="lg" scrollable>
            <pdf :resize="true" :src="pdfUrl" :page="currentPage" v-if="pdfUrl" @numpages="updatePageCount">
                <template slot="loading">
                    <Pulse />
                </template>
            </pdf>
            <template slot="modal-footer">
                <b-button variant="info" @click="print"><printer-icon></printer-icon> Print</b-button>
                <b-button :disabled="!canMoveBack" @click="previous"><chevron-left-icon /> Previous Page</b-button>
                <b-button :disabled="!canMoveForward" @click="next">Next Page <chevron-right-icon /></b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Pulse from '../../components/loaders/Pulse'
    import ChevronRightIcon from "vue-material-design-icons/ChevronRight";
    import ChevronLeftIcon from "vue-material-design-icons/ChevronLeft";
    import PrinterIcon from "vue-material-design-icons/Printer";

    export default {
        name: "PreviewEntryModal",
        components: {
            ChevronLeftIcon,
            ChevronRightIcon,
            PrinterIcon,
            pdf: () => import('pdfvuer'),
            Pulse
        },
        data() {
            return {
                pdfUrl: '',
                numPages: 0,
                currentPage: 1
            }
        },
        methods: {
            show(entryId) {
                this.currentPage = 1;

                // Revoke any previous object URL to avoid leaks
                if (this.pdfUrl) {
                    URL.revokeObjectURL(this.pdfUrl);
                }
                this.pdfUrl = null;

                // Fetch PDF via v2 API using authenticated session
                this.$api.v2.get(`entries/${entryId}/pdf`, { responseType: 'blob' }).then((response) => {
                    const body = response.body;
                    const blob = body instanceof Blob ? body : new Blob([body], { type: 'application/pdf' });
                    this.pdfUrl = URL.createObjectURL(blob);
                    this.$refs.modal.show();
                }).catch((resp) => {
                    if (this.$httpError) {
                        this.$httpError('Failed to load entry PDF', resp);
                    }
                });
            },
            updatePageCount(pageCount) {
                this.numPages = pageCount;
            },
            next() {
                this.currentPage++;
            },
            previous() {
                this.currentPage--;
            },
            print() {
                this.$printUtils.printPDF(this.pdfUrl);
            }
        },
        computed: {
            canMoveForward() {
                return this.currentPage < this.numPages;
            },
            canMoveBack() {
                return this.currentPage > 1;
            }
        },
        beforeDestroy() {
            if (this.pdfUrl) {
                URL.revokeObjectURL(this.pdfUrl);
            }
        }
    }
</script>

<style scoped>

</style>
